module.exports = "<!-- Main view/routes wrapper-->\r\n<router-outlet></router-outlet>"